<div>
    <button
            matIconButton
            id="collection-manager-toolbar-button"
            class="mat-icon-toggle-button"
            [class.selected]="displayPanel"
            type="button"
            matTooltip="{{ !displayPanel ? 'Collections Tool' : null }}"
            (click)="togglePanelDisplay()"
            matTooltipPosition="right">
        <mat-icon>layers_clear</mat-icon>
    </button>

    <div class="toolbar-panel-container" [hidden]="!displayPanel">
        <div class="sidebar-component layer-manager-container">
            <div class="row">
                <mat-tab-group [selectedIndex]="0" *ngIf="displayPanel">
                    <mat-tab label="Imagery" class="collection-tab">
                        <div *ngIf="collectionLayers?.length" class="overlay-container dragable-container" cdkDropList
                             (cdkDropListDropped)="changeCollectionOrder($event)">
                            <ng-container *ngFor="let layer of viewerService.collectionLayers$ | async">
                                <app-layer-item
                                        [mode3D]="viewerService.is3DMode()"
                                        cdkDrag
                                        [debug]="enableDebugOptions"
                                        (showInfoEvent)="showLayerInfo($event)"
                                        [zoomLevel]="viewerService.getZoom()"
                                        [layer]="layer"
                                        (updateCollectionOrderEvent)="updateCollectionOrder()"
                                        (fitBBoxEvent)="fitToBbox($event)"
                                        (changeVisibilityEvent)="changeVisibility($event)"
                                        (toggleContrastEvent)="toggleLayerContrast($event)"></app-layer-item>
                            </ng-container>
                        </div>
                    </mat-tab>
                    <mat-tab label="Overlays" class="collection-tab">
                        <app-overlay-manager
                                [overlayLayers]="viewerService.overlayLayers$ | async"></app-overlay-manager>
                    </mat-tab>
                </mat-tab-group>
            </div>
            <div style="height: 400px">
                <app-dev-coverage-panel
                        [enabledAOIs]="(this.viewerService.projectStatus$ | async)?.enabledAOIs"></app-dev-coverage-panel>
            </div>
        </div>
    </div>
</div>
